import { render, staticRenderFns } from "./AddressComponent.vue?vue&type=template&id=69407920&scoped=true&"
import script from "./AddressComponent.vue?vue&type=script&lang=js&"
export * from "./AddressComponent.vue?vue&type=script&lang=js&"
import style0 from "./AddressComponent.vue?vue&type=style&index=0&id=69407920&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.10.0@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69407920",
  null
  
)

export default component.exports